import { kMaps } from "./maps";

export const kMapImageUrls: { mapId: string; url: string }[] = [
  {
    url: "https://workplaced-public-assets-common.s3.eu-west-1.amazonaws.com/booking-demo/demo-office-floor-plan-0.png",
    mapId: kMaps[0].id,
  },
  {
    url: "https://workplaced-public-assets-common.s3.eu-west-1.amazonaws.com/booking-demo/demo-office-floor-plan-0.png",
    mapId: kMaps[1].id,
  },
];
